import { useResilientQuery } from '@famly/stat_apollo-query';
import { FetchEmployeesWithoutContractCountQuery } from './fetch-employees-without-contract-count.query';
/**
 * Hook to fetch the count of employees without a contract for a site.
 *
 * @param options - Apollo query options including variables with siteId.
 * @returns Query result with employees without contract count and loading state.
 */
export const useFetchEmployeesWithoutContractCount = (options) => {
    return useResilientQuery(FetchEmployeesWithoutContractCountQuery, options);
};
